import axios from 'axios'

import { sortArrayOfDates } from '@utils/data/date-time'

export const state = {
  loading: false,
  cachedDeviceEvents: null,
  cachedDeviceConditions: null,
  cachedDeviceCycles: null,
  cachedDeviceActivities: null,
  cachedDeviceStateAggregateHour: null,
  cachedDeviceStateAggregateHourDevice: null,
  cachedDeviceCycleByDevice: null,
  cachedDeviceInsights: null,
  cachedDeviceInsightsDevice: null,
  changedDeviceActivities: [],
  changedDeviceActivitiesAsObjectArray: [],
}

export const getters = {
  loading(state) {
    return state.loading
  },

  cachedDeviceEvents(state) {
    return state.cachedDeviceEvents
  },

  cachedDeviceConditions(state) {
    return state.cachedDeviceConditions
  },

  cachedDeviceCycles(state) {
    return state.cachedDeviceCycles
  },

  cachedDeviceActivities(state) {
    return state.cachedDeviceActivities
  },

  cachedDeviceStateAggregateHour(state) {
    return state.cachedDeviceStateAggregateHour
  },

  cachedDeviceStateAggregateHourDevice(state) {
    return state.cachedDeviceStateAggregateHourDevice
  },

  cachedDeviceCycleByDevice(state) {
    return state.cachedDeviceCycleByDevice
  },

  cachedDeviceInsights(state) {
    return state.cachedDeviceInsights
  },

  cachedDeviceInsightsDevice(state) {
    return state.cachedDeviceInsights
  },

  cachedDeviceInsightsWithFilters(state, getters, rootState) {
    let cachedDeviceInsightsWithFilters = [...(state.cachedDeviceInsights || [])]

    if (rootState.filters.device.name) {
      if (rootState.filters.device.searchGroup) {
        cachedDeviceInsightsWithFilters = cachedDeviceInsightsWithFilters.filter(
          (deviceInsight) => {
            return deviceInsight.deviceGroupName
              .toUpperCase()
              .includes(rootState.filters.device.name)
          }
        )
      } else {
        cachedDeviceInsightsWithFilters = cachedDeviceInsightsWithFilters.filter(
          (deviceInsight) => {
            return deviceInsight.deviceName
              .toUpperCase()
              .includes(rootState.filters.device.name)
          }
        )
      }
    }

    if (rootState.filters.shiftPatternName) {
      cachedDeviceInsightsWithFilters = cachedDeviceInsightsWithFilters.filter(
        (deviceInsight) => {
          return deviceInsight.shiftPatternName.includes(
            rootState.filters.shiftPatternName
          )
        }
      )
    }

    return cachedDeviceInsightsWithFilters
  },

  changedDeviceActivities(state) {
    return state.changedDeviceActivities
  },

  changedDeviceActivitiesAsObjectArray(state) {
    return state.changedDeviceActivitiesAsObjectArray
  },
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_GET_DEVICEEVENTS_CACHE(state, deviceEvents) {
    state.cachedDeviceEvents = deviceEvents
  },

  SET_GETDEVICECONDITIONS_CACHE(state, deviceEvents) {
    state.cachedDeviceConditions = deviceEvents
  },

  SET_GET_DEVICECYCLES_CACHE(state, deviceEvents) {
    state.cachedDeviceCycles = deviceEvents
  },

  SET_GET_DEVICEACTIVITIES_CACHE(state, deviceEvents) {
    state.cachedDeviceActivities = deviceEvents
  },

  SET_GETDEVICESTATEAGGREGATEHOUR_CACHE(state, deviceStateAggregateHour) {
    state.cachedDeviceStateAggregateHour = deviceStateAggregateHour
  },

  SET_GET_DEVICESTATEAGGREGATEHOUR_CACHE_DEVICE(state, deviceStateAggregateHour) {
    state.cachedDeviceStateAggregateHourDevice = deviceStateAggregateHour
  },

  SET_GET_DEVICECYCLEBYDEVICE_CACHE(state, deviceCycleBydevice) {
    state.cachedDeviceCycleByDevice = deviceCycleBydevice
  },

  SET_GET_DEVICEINSIGHTS_CACHE(state, deviceStateAggregateHour) {
    state.cachedDeviceInsights = deviceStateAggregateHour
  },

  SET_GET_DEVICEINSIGHTS_DEVICE(state, deviceStateAggregateHour) {
    state.cachedDeviceInsightsDevice = deviceStateAggregateHour
  },

  SET_CHANGED_DEVICE_ACTIVITIES(state, changedDeviceActivities) {
    state.changedDeviceActivities = sortArrayOfDates([
      ...state.changedDeviceActivities,
      ...changedDeviceActivities,
    ])
  },

  SET_CHANGED_DEVICE_ACTIVITIES_ASOBJECTARRAY(
    state,
    changedDeviceActivitiesAsObjectArray
  ) {
    state.changedDeviceActivitiesAsObjectArray.push(changedDeviceActivitiesAsObjectArray)
  },

  CLEAR_CHANGED_DEVICE_ACTIVITIES(state, changedDeviceActivities) {
    state.changedDeviceActivities = []
  },
  CLEAR_CHANGED_DEVICE_ACTIVITIES_ASOBJECTARRAY(state, changedDeviceActivities) {
    state.changedDeviceActivitiesAsObjectArray = []
  },
}

export const actions = {
  getDeviceEvents({ commit, state, rootState }, { clearCache, deviceId, dateRange }) {
    commit('SET_LOADING', true)

    // 1. Fetch the DeviceEvents from the API and cache it in case
    // we need it again in the future.
    let url =
      '/api/services/app/deviceInsights/GetDeviceEventsByDevice' +
      '?StartDate=' +
      dateRange.start +
      '&EndDate=' +
      dateRange.end

    if (deviceId) {
      url = url + '&DeviceId=' + deviceId
    }

    return axios
      .get(url)
      .then((response) => {
        let deviceEvents = []
        let deviceConditions = []
        let deviceCycles = []
        let deviceActivities = []
        let deviceCycleCount = []
        let nextCycleStartTime = null

        let transformDeviceEvents = function(deviceEvent, i, deviceEvents) {
          deviceEvent.editable = false

          if ((i > 0) & (i < deviceEvents.length)) {
            deviceEvent.end = deviceEvents[i - 1].start
          }

          if (deviceEvent.condition != null) {
            let condition = { ...deviceEvent.condition }

            condition.id = Math.random()
            condition.start = deviceEvent.start

            condition.className = 'timeline-condition'
            condition.group = deviceEvent.group
            condition.content = ''
            condition.type = 'point'
            condition.editable = false
            deviceConditions.push(condition)
          }

          if (deviceEvent.cycleIdSequence === 1) {
            if (nextCycleStartTime) {
              deviceEvent.cycle.end = nextCycleStartTime
            } else {
              deviceEvent.cycle.end = deviceEvents[0].start
            }

            nextCycleStartTime = deviceEvent.cycle.start

            let cycle = { ...deviceEvent.cycle }

            cycle.id = Math.random()
            cycle.className = 'cycle'
            cycle.group = 'Events'
            cycle.content = '<p class="visEvent">' + cycle.name + '</p>'
            cycle.type = 'background'
            cycle.editable = false
            deviceCycles.push(cycle)
          }

          if (
            (deviceEvent.activity !== null && i === deviceEvents.length - 1) ||
            deviceEvent.activityIdSequence === 1
          ) {
            let activity = { ...deviceEvent.activity }

            activity.id = Math.random()
            activity.className = activity.available
              ? 'activityAvailable'
              : 'activityUnAvailable'
            activity.group = 'Activity'
            activity.content = '<p class="visActivity">' + activity.name + '</p>'
            activity.start = deviceEvent.start
            activity.end = deviceEvent.end
            activity.editable = {
              updateTime: false,
              updateGroup: false,
              remove: false,
            }
            deviceActivities.push(activity)
          }

          if (deviceEvent.cycleCountSequence === 1) {
            let cycle = { ...deviceEvent.cycle }
            let count =
              deviceEvent.cycleCount - deviceEvent.cycle.countAtStart > 0
                ? deviceEvent.cycleCount - deviceEvent.cycle.countAtStart
                : ''

            cycle.id = Math.random()
            cycle.start = deviceEvent.start
            cycle.className = 'timeline-cycle-count display-when-active'
            cycle.group = 'Events'
            cycle.content = count.toString()
            cycle.type = 'box'
            if (count > 0) {
              deviceCycleCount.push(cycle)
            }
          }
          commit('SET_LOADING', false)
          return deviceEvent
        }

        deviceEvents = response.data.items.map(transformDeviceEvents)

        let finalActivities = deviceActivities.map(function(
          activity,
          i,
          deviceActivities
        ) {
          if ((i > 0) & (i < deviceActivities.length)) {
            activity.end = deviceActivities[i - 1].start
          } else if (i === 0) {
            activity.end = deviceEvents[0].end
          }
          return activity
        })

        commit('SET_GETDEVICECONDITIONS_CACHE', deviceConditions)
        commit('SET_GET_DEVICECYCLES_CACHE', [...deviceCycles, ...deviceCycleCount])
        commit('SET_GET_DEVICEACTIVITIES_CACHE', finalActivities)
        commit('SET_GET_DEVICEEVENTS_CACHE', deviceEvents)

        return deviceEvents
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
      .finally(() => {})
  },

  getDeviceStateAggregateHour(
    { commit, state, rootState },
    { clearCache, dateRange, deviceId }
  ) {
    commit('SET_LOADING', true)
    // 1. Check if we've already fetched and cachedGroups the activity groups.
    const matchedAggregateHour = state.cachedDeviceStateAggregateHour
    if (!clearCache && matchedAggregateHour) {
      return Promise.resolve(matchedAggregateHour)
    }

    // 2. Fetch the deviceStateAggregateHour from the API and cache it in case
    // we need it again in the future.
    let url =
      '/api/services/app/deviceInsights/GetDeviceStateAggregateHour' +
      '?StartDate=' +
      dateRange.start +
      '&EndDate=' +
      dateRange.end

    if (deviceId) {
      url = url + '&deviceId=' + deviceId
    }

    return axios
      .get(url)
      .then((response) => {
        const deviceStateAggregateHour = response.data

        if (!deviceId) {
          commit('SET_GETDEVICESTATEAGGREGATEHOUR_CACHE', deviceStateAggregateHour)
        } else {
          commit(
            'SET_GET_DEVICESTATEAGGREGATEHOUR_CACHE_DEVICE',
            deviceStateAggregateHour
          )
        }

        commit('SET_LOADING', false)
        return deviceStateAggregateHour
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  getDeviceCycleByDevice(
    { commit, state, rootState },
    { clearCache, deviceId, dateRange }
  ) {
    commit('SET_LOADING', true)
    // 1. Check if we've already fetched and cachedGroups the activity groups.
    const matchedDeviceCycleBydevice = state.cachedDeviceCycleByDevice
    if (!clearCache && matchedDeviceCycleBydevice) {
      return Promise.resolve(matchedDeviceCycleBydevice)
    }

    // 2. Fetch the deviceCycleBydevice from the API and cache it in case
    // we need it again in the future.
    return axios
      .get(
        '/api/services/app/deviceInsights/GetDeviceCycleByDevice' +
          '?StartDate=' +
          dateRange.start +
          '&EndDate=' +
          dateRange.end
      )
      .then((response) => {
        const matchedDeviceCycleBydevice = response.data

        commit('SET_GET_DEVICECYCLEBYDEVICE_CACHE', matchedDeviceCycleBydevice)
        commit('SET_LOADING', false)
        return matchedDeviceCycleBydevice
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  getDeviceInsights({ commit, state, rootState }, { clearCache, dateRange, deviceName }) {
    commit('SET_LOADING', true)
    // 1. Check if we've already fetched and cachedGroups the activity groups.
    const matchedDeviceInsights = state.cachedDeviceInsights
    if (!clearCache && matchedDeviceInsights) {
      return Promise.resolve(matchedDeviceInsights)
    }

    // 2. Fetch the deviceInsights from the API and cache it in case
    // we need it again in the future.
    let url =
      '/api/services/app/deviceInsights/getDeviceInsights' +
      '?StartDate=' +
      dateRange.start +
      '&EndDate=' +
      dateRange.end

    if (deviceName) {
      url = url + '&deviceName=' + deviceName
    }

    return axios
      .get(url)
      .then((response) => {
        const deviceInsights = response.data

        if (!deviceName) {
          commit('SET_GET_DEVICEINSIGHTS_CACHE', deviceInsights)
        } else {
          commit('SET_GET_DEVICEINSIGHTS_CACHE_DEVICE', deviceInsights)
        }

        commit('SET_LOADING', false)
        return deviceInsights
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  changeDeviceActivities({ commit, state, rootState }, { deviceActivityTime, reset }) {
    if (reset) {
      commit('CLEAR_CHANGED_DEVICE_ACTIVITIES')
      commit('CLEAR_CHANGED_DEVICE_ACTIVITIES_ASOBJECTARRAY')
    } else {
      commit('SET_CHANGED_DEVICE_ACTIVITIES', deviceActivityTime)

      if (state.changedDeviceActivities.length >= 2) {
        let activityDates = sortArrayOfDates([...state.changedDeviceActivities])

        for (
          var i = state.changedDeviceActivitiesAsObjectArray.length;
          i < activityDates.length;
          i += 2
        ) {
          if (activityDates[i + 1] != null) {
            commit('SET_CHANGED_DEVICE_ACTIVITIES_ASOBJECTARRAY', {
              start: activityDates[i],
              end: activityDates[i + 1],
            })
          }
        }
      }
    }
  },

  doInsightsLogin({ commit, state, rootState }) {
    commit('SET_LOADING', true)

    // 2. Fetch the deviceInsights from the API and cache it in case
    // we need it again in the future.

    return axios
      .post(
        'https://insights.openindustry.org/login',
        'remember=on&email=max%40cncdata.co.uk&password=',
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      )
      .then((response) => {
        const deviceInsights = response.data
        return deviceInsights
      })
      .catch((error) => {
        commit('SET_LOADING', false)
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },
}
